import React from 'react';
import { StructuredData } from '../shared/StructuredData';

export function ServiceStructuredData() {
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Laser Hair Removal",
    "provider": {
      "@type": "Organization",
      "name": "Milan Laser Hair Removal"
    },
    "areaServed": {
      "@type": "Country",
      "name": "United States"
    },
    "serviceType": "Permanent Hair Reduction",
    "availableChannel": {
      "@type": "ServiceChannel",
      "serviceUrl": "https://www.milanlaser.com/locations"
    }
  };

  return <StructuredData>{serviceSchema}</StructuredData>;
} 